module.exports = __webpack_public_path__ + "media/attack_on_titan.b9e4de7f.mp3";